import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useMutation } from '@tanstack/react-query'
import { authApi } from '../../api/client'
import { useAuthStore } from '../../store/authStore'
import toast from 'react-hot-toast'

export default function ChangePasswordPage() {
  const [currentPassword, setCurrentPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const { setMustChangePassword } = useAuthStore()
  const navigate = useNavigate()

  const changeMut = useMutation({
    mutationFn: () => authApi.changePassword(currentPassword, newPassword),
    onSuccess: () => {
      setMustChangePassword(false)
      toast.success('Password changed successfully! The platform is now ready.')
      navigate('/admin')
    },
    onError: (e: any) => toast.error(e.response?.data?.detail || 'Password change failed'),
  })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (newPassword !== confirmPassword) {
      toast.error('New passwords do not match')
      return
    }
    changeMut.mutate()
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-16">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <Link to="/" className="inline-flex items-baseline gap-1 font-extrabold text-2xl no-underline mb-4">
            <span className="text-brand-blue">PacketFive</span><span className="text-brand-green2">Academy</span>
            <span className="text-brand-muted text-sm font-normal ml-1">LMS</span>
          </Link>
          <h1 className="text-2xl font-extrabold">Change Default Password</h1>
          <p className="text-brand-muted text-sm mt-2">
            You must change the default admin password before the platform can be used.
          </p>
        </div>

        <form className="card space-y-4" onSubmit={handleSubmit}>
          <div>
            <label className="label">Current Password</label>
            <input
              className="input" type="password" placeholder="Current password"
              value={currentPassword} onChange={e => setCurrentPassword(e.target.value)}
              required autoFocus
            />
          </div>
          <div>
            <label className="label">New Password</label>
            <input
              className="input" type="password" placeholder="Min. 8 characters"
              value={newPassword} onChange={e => setNewPassword(e.target.value)}
              required minLength={8}
            />
          </div>
          <div>
            <label className="label">Confirm New Password</label>
            <input
              className="input" type="password" placeholder="Confirm new password"
              value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)}
              required minLength={8}
            />
          </div>
          <button type="submit" className="btn-primary w-full justify-center" disabled={changeMut.isPending}>
            {changeMut.isPending ? 'Changing…' : 'Change Password & Unlock Platform'}
          </button>
        </form>
      </div>
    </div>
  )
}
